import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Permission } from '../common/enums/permissions';
import { AuthGuard } from '../core/authentication/auth.guard';
import { PermissionGuard } from '../core/authentication/permission.guard';
import { HasPermissionToModuleGuard, ModuleName } from '../subscription-package';
import { AbsenceMainComponent } from './absence-main/absence-main.component';
import { AbsencesPerYearListComponent } from './absences-per-year-list/absences-per-year-list.component';
import { AbsencesComponent } from './absences/absences.component';

const routes: Routes = [
  {
    path: 'absences',
    component: AbsenceMainComponent,
    canActivate: [AuthGuard, PermissionGuard, HasPermissionToModuleGuard],
    data: {
      permissions: [Permission.ViewMyAbsences, Permission.ViewWorkerAbsences, Permission.ViewAbsenceOnWorkerProfile, Permission.Supervisor],
      moduleName: ModuleName.Absences,
    },
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      {
        path: 'list',
        component: AbsencesComponent,
        canActivate: [AuthGuard, PermissionGuard],
        data: {
          permissions: [Permission.ViewMyAbsences, Permission.ViewWorkerAbsences, Permission.ViewAbsenceOnWorkerProfile, Permission.Supervisor],
        },
      },
      {
        path: 'list/:year',
        component: AbsencesComponent,
        canActivate: [AuthGuard, PermissionGuard],
        data: {
          permissions: [Permission.ViewMyAbsences, Permission.ViewWorkerAbsences, Permission.ViewAbsenceOnWorkerProfile, Permission.Supervisor],
        },
      },
      {
        path: ':year',
        component: AbsencesPerYearListComponent,
        pathMatch: 'full',
        canActivate: [AuthGuard, PermissionGuard],
        data: {
          permissions: [Permission.ViewMyAbsences, Permission.ViewWorkerAbsences, Permission.ViewAbsenceOnWorkerProfile, Permission.Supervisor],
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AbsencesRoutingModule {}
